import React from 'react';
import { Autocomplete, Box, TextField, Typography } from '@mui/material';

/** Filtro desplegable y buscable para seleccionar una tarjeta. */
const GestorSidebar = ({ navItems, currentSection, onSelectSection }) => {
  const selectedItem = navItems.find((item) => String(item.id) === String(currentSection)) || navItems[0] || null;

  return (
    <Box sx={{ width: '100%', minWidth: 0 }}>
      <Typography
        component="label"
        htmlFor="section-filter"
        sx={{ display: 'block', mb: 0.75, fontSize: 14, fontWeight: 600, color: '#344054' }}
      >
        Filtrar por tarjeta
      </Typography>
      <Autocomplete
        id="section-filter"
        options={navItems}
        value={selectedItem}
        onChange={(_, item) => { if (item) onSelectSection(item.id); }}
        getOptionLabel={(item) => item?.label || ''}
        isOptionEqualToValue={(option, value) => String(option.id) === String(value.id)}
        getOptionKey={(option) => String(option.id)}
        fullWidth
        disableClearable
        size="small"
        renderOption={(props, item) => (
          <Box component="li" {...props} key={item.id} sx={{ display: 'flex', gap: 2 }}>
            <span>{item.label}</span>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Escribí para buscar una tarjeta…"
            inputProps={{ ...params.inputProps, 'aria-label': 'Buscar tarjeta' }}
            sx={{ '& .MuiOutlinedInput-root': { minHeight: 48, borderRadius: '12px', backgroundColor: '#FFFFFF' }, '& .MuiAutocomplete-clearIndicator': { display: 'none' } }}
          />
        )}
        noOptionsText="No se encontraron tarjetas"
      />
    </Box>
  );
};

export default GestorSidebar;
